module.exports = __webpack_public_path__ + "static/media/1_A1_25.b8eb3e96.png";